import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import { Link } from "react-router-dom";

const pin = (label, cls) =>
  L.divIcon({ className: "", html: `<div class="qfq-pin ${cls}" style="width:28px;height:28px">${label}</div>`, iconSize: [28, 28], iconAnchor: [14, 14] });

function Fit({ points, center }) {
  const map = useMap();
  useEffect(() => {
    const t = setTimeout(() => map.invalidateSize(), 150);
    return () => clearTimeout(t);
  });
  useEffect(() => {
    if (points.length > 1) {
      map.fitBounds(points, { padding: [30, 30], maxZoom: 14 });
    } else if (points.length === 1) {
      map.setView(points[0], 14);
    } else if (center) {
      map.setView(center, 12);
    }
  }, [map, points, center]);
  return null;
}

export function ResultsMap({ items, center, activeId, height = "100%" }) {
  const located = items.filter((b) => b.lat != null && b.lon != null);
  const points = located.map((b) => [b.lat, b.lon]);
  const c = center ? [center.lat, center.lon] : points[0] || [46.6, 2.4];
  return (
    <div style={{ height }} className="overflow-hidden rounded-xl border border-slate-200" data-testid="results-map">
      <MapContainer center={c} zoom={center ? 12 : 6} style={{ height: "100%", width: "100%" }} scrollWheelZoom>
        <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Fit points={points} center={center ? c : null} />
        {located.map((b) => (
          <Marker key={b.id} position={[b.lat, b.lon]} zIndexOffset={b.id === activeId ? 1000 : 0}
            icon={pin(items.indexOf(b) + 1, b.id === activeId ? "active" : b.plan === "pro" ? "pro" : "")}>
            <Popup>
              <Link to={`/entreprise/${b.id}`} className="font-semibold">{b.name}</Link>
              <div className="text-xs">{b.rating ? `★ ${b.rating.toFixed(1)}` : "Pas encore noté"}</div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
